module.exports = __webpack_public_path__ + "static/media/A6-Portrait-H1.9a9d62ce.png";